import { isNoSessionRoute } from 'features/auth/utils/appRenderRule';
import { readCachedBrand, readLastBrandFile } from './brandCache';
import { protocolIdFromPath } from './protocolIdFromPath';
import type { BrandFile } from '@hub/common';

// The brand a page at `pathname` shows without a request: the cached file of
// the protocol in a start link or participation path; on the signed-out and
// auth callback pages the cached file of the last brand's pointer.
export const brandForPath = (pathname: string): BrandFile | undefined => {
  if (isNoSessionRoute(pathname)) {
    return readLastBrandFile();
  }
  const protocolId = protocolIdFromPath(pathname);
  return protocolId === undefined
    ? undefined
    : readCachedBrand(protocolId)?.file;
};
